/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdLoyaltyPoints200Ok
 */
export interface GetCharactersCharacterIdLoyaltyPoints200Ok {
    /**
     * corporation_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdLoyaltyPoints200Ok
     */
    corporationId: number;
    /**
     * loyalty_points integer
     * @type {number}
     * @memberof GetCharactersCharacterIdLoyaltyPoints200Ok
     */
    loyaltyPoints: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdLoyaltyPoints200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdLoyaltyPoints200Ok(value: object): value is GetCharactersCharacterIdLoyaltyPoints200Ok {
    if (!('corporationId' in value) || value['corporationId'] === undefined) return false;
    if (!('loyaltyPoints' in value) || value['loyaltyPoints'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdLoyaltyPoints200OkFromJSON(json: any): GetCharactersCharacterIdLoyaltyPoints200Ok {
    return GetCharactersCharacterIdLoyaltyPoints200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdLoyaltyPoints200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdLoyaltyPoints200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'corporationId': json['corporation_id'],
        'loyaltyPoints': json['loyalty_points'],
    };
}

export function GetCharactersCharacterIdLoyaltyPoints200OkToJSON(json: any): GetCharactersCharacterIdLoyaltyPoints200Ok {
    return GetCharactersCharacterIdLoyaltyPoints200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdLoyaltyPoints200OkToJSONTyped(value?: GetCharactersCharacterIdLoyaltyPoints200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'corporation_id': value['corporationId'],
        'loyalty_points': value['loyaltyPoints'],
    };
}

